import { Avatar, Flex, Text } from '@chakra-ui/react';

export type TMemberCell = {
    name: string;
    avatar: string;
    email: string;
};

const MemberCell = ({ name, avatar, email }: TMemberCell) => (
    <Flex gap="12px" alignItems="center">
        <Avatar src={avatar} boxSize="40px" gap="12px" alignItems="center" name={name} />
        <Flex flexDirection="column" gap="4px">
            <Text fontSize="14px" color="gray.900" fontWeight={700} lineHeight={1.1}>
                {name}
            </Text>
            <Text fontSize="14px" color="gray.500" fontWeight={500} lineHeight={1.1}>
                {email}
            </Text>
        </Flex>
    </Flex>
);

export default MemberCell;
